<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" v-model="model">
      <v-tab class="pl-0 ml-0" :href="`#tab-1`">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Live Trades
      </v-tab>
      <v-tab :href="`#tab-2`"> Close Trades </v-tab>
      <v-tab :href="`#tab-3`"> Charts </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <live-tab></live-tab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card flat>
            <close-tab></close-tab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <v-card flat>
            <chart-tab></chart-tab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import ChartTab from "./ChartTab.vue";
import CloseTab from "./CloseTab.vue";
import LiveTab from "./LiveTab.vue";
export default {
  name: "LiveTradeTabs",
  data() {
    return {
      model: "tab-2",
    };
  },
  components: {
    LiveTab,
    CloseTab,
    ChartTab,
  },
};
</script>
